<script setup>
import { computed } from 'vue';

import VisionCard from '@/components/VisionAi/VisionCard.vue';
import { useFlagStore } from '@/stores/flag';

const props = defineProps({
  useSummaryMessage: {
    type: Boolean,
    default: false,
  },
});

const flagStore = useFlagStore();
</script>

<template>
  <VisionCard>
    <template v-if="props.useSummaryMessage">
      <p>
        <strong>Welcome to Vision AI Summaries!</strong><br /><br />

        By clicking "Summarize", Vision AI will instantly analyze your data to highlight important
        trends and generate a report-ready digest.<br /><br />

        Vision AI Summaries are available in Community, Dashboards and Social Listening.
      </p>
    </template>
    <template v-else>
      <span class="text-main-bold"
        >Hi! I'm Vision AI - now smarter and ready to help with your social data!</span
      >
      <br /><br />
      <p class="text-main">
        Ask me anything about your social performance or click Summarize on select pages.<br /><br />
      </p>
      <p class="text-main">
        💡 I can analyze trends, compare metrics, or break down post performance - just tell me what
        you need!
      </p>
    </template>
  </VisionCard>
</template>
